import React from "react";
import { Box, Text, Button, Avatar, Icon, useColorModeValue } from "@chakra-ui/react";
import { MdPersonAdd } from "react-icons/md";
import Card from "horizon/components/card/Card";
import logo from "../../assets/img/logo.png";
import p_cover from "../../assets/img/damir-bosnjak.jpg";
import AdminMembers from "../../profileData/adminMembers";

/**
 * Admin profile card with cover photo, avatar, admin list, and add-admin button.
 * @param {Object} props
 * @param {Object} props.profile - Admin profile data (name, email, photo, cover_photo)
 * @param {number} props.right - Admin right level (1=admin, 2=super admin)
 * @param {Function} props.onAddClick - Handler to open the add-admin dialog
 * @returns {React.ReactElement}
 */
function ProfileCard({ profile, right, onAddClick }) {
    const nameColor = useColorModeValue("secondaryGray.900", "white");
    const emailColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    const coverSrc = profile?.cover_photo && profile?.cover_photo !== "null" ? profile.cover_photo : p_cover;
    const avatarImgSrc = profile?.photo && profile?.photo !== "null" ? profile.photo : logo;

    return (
        <Card p="0" overflow="hidden">
            <Box h="120px" bgImage={`url(${coverSrc})`} bgSize="cover" bgPosition="center" />
            <Box px="20px" pb="20px" textAlign="center">
                <Avatar src={avatarImgSrc} w="80px" h="80px" mt="-40px" mb="16px" mx="auto" border="3px solid" borderColor={useColorModeValue("white", "navy.800")} />
                <Text color={nameColor} fontSize="lg" fontWeight="600" mb="4px">{profile.name}</Text>
                <Text color={emailColor} fontSize="0.9rem" mb="24px">{profile.email}</Text>
                <AdminMembers userConnectedRight={right} />
                <Button mt="24px" w="100%" colorScheme="brand" leftIcon={<Icon as={MdPersonAdd} />}
                    isDisabled={right === 1} onClick={onAddClick}>Ajouter un admin</Button>
            </Box>
        </Card>
    );
}

export default ProfileCard;
